module.exports = __webpack_public_path__ + "static/fossasia-c2eb4c3e29527ad5ce969148bfc51854.png";